import MuiBadge, { type BadgeProps } from "@mui/material/Badge";

export type { BadgeProps };

export function Badge(props: BadgeProps) {
  return <MuiBadge {...props} />;
}
